import gql from 'graphql-tag';
import { ATTACHMENT_FIELDS } from './projectDocumentsFragment';

/**
 * Data of the block project-sales-report-build ("Sales Protokoll: Bericht generieren"): the
 * generated PDF of the unified list (type SALES_REPORT) and its build state; the API returns only
 * that type. Read through `Project.blocks.salesReportBuild`, which checks the block's read
 * permission.
 */
export const PROJECT_SALES_REPORT_BUILD_FIELDS = gql`
  fragment projectSalesReportBuildFields on ProjectSalesReportBuildBlock {
    id
    number
    attachments {
      ${ATTACHMENT_FIELDS}
    }
    attachmentBuildStates {
      attachmentType
      state
    }
  }
`;
